import React from 'react';
import { Select, SelectOption } from '@indigo-ag/component-module';
import { RiskClassificationLevel } from '@indigo-ag/schema';

import i18next from 'i18next';

interface RiskLevelSelectProps {
  value: RiskClassificationLevel | null;
  onChange: (value: RiskClassificationLevel | null) => void;
  error?: string | null;
  disabled?: boolean;
}

const riskLevelOptions: SelectOption<RiskClassificationLevel>[] = [
  { name: i18next.t('preAnalysisRiskLevel-very-high'), value: RiskClassificationLevel.VERY_HIGH },
  { name: i18next.t('preAnalysisRiskLevel-high'), value: RiskClassificationLevel.HIGH },
  { name: i18next.t('preAnalysisRiskLevel-medium'), value: RiskClassificationLevel.MEDIUM },
  { name: i18next.t('preAnalysisRiskLevel-low'), value: RiskClassificationLevel.LOW },
  { name: i18next.t('preAnalysisRiskLevel-very-low'), value: RiskClassificationLevel.VERY_LOW },
  { name: i18next.t('preAnalysisRiskLevel-not-classified'), value: RiskClassificationLevel.NOT_CLASSIFIED }
];

export const RiskLevelSelect: React.FC<RiskLevelSelectProps> = ({ value, onChange, error, disabled }) => {
  return (
    <Select
      label={i18next.t('preAnalysisRiskLevel-label')}
      name="risk-level-select"
      placeholder={i18next.t('preAnalysisRiskLevel-placeholder')}
      value={value}
      onChange={e => onChange(e.target.value)}
      options={riskLevelOptions}
      error={error}
      disabled={disabled}
    />
  );
};
